"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWidgetLoadStart = void 0;
var logDeprecationNote_1 = require("../utils/logDeprecationNote");
/** @deprecated No need to invoke this method anymore */
var reportWidgetLoadStart = function () {
    (0, logDeprecationNote_1.logDeprecationNote)("\"reportWidgetLoadStart\" method is deprecated. Just remove its usage");
};
exports.reportWidgetLoadStart = reportWidgetLoadStart;
//# sourceMappingURL=reportWidgetLoadStart.js.map